const tripFailureTypeLabels: Record<number, string> = {
  0: "Pickup",
  1: "Drop"
};

export const formatTripFailureType = (value: any) => {
  const numericType = Number(value);
  return tripFailureTypeLabels[numericType] ?? value ?? "-";
};

export const NeoTripFailureType: React.FC<any> = ({data, uid}) => {
  const value = data?.[uid];
  return <span>{formatTripFailureType(value)}</span>;
};
